export default __webpack_public_path__ + "static/media/COMM_VERBAL.514d781b.pdf";